const states = {
    US: [
        { code: "AL", name: "Alabama" },
        { code: "AK", name: "Alaska" },
        { code: "AZ", name: "Arizona" },
        { code: "AR", name: "Arkansas" },
        { code: "CA", name: "California" },
        { code: "CO", name: "Colorado" },
        { code: "CT", name: "Connecticut" },
        { code: "DE", name: "Delaware" },
        { code: "FL", name: "Florida" },
        { code: "GA", name: "Georgia" },
        { code: "HI", name: "Hawaii" },
        { code: "ID", name: "Idaho" },
        { code: "IL", name: "Illinois" },
        { code: "IN", name: "Indiana" },
        { code: "IA", name: "Iowa" },
        { code: "KS", name: "Kansas" },
        { code: "KY", name: "Kentucky" },
        { code: "LA", name: "Louisiana" },
        { code: "ME", name: "Maine" },
        { code: "MD", name: "Maryland" },
        { code: "MA", name: "Massachusetts" },
        { code: "MI", name: "Michigan" },
        { code: "MN", name: "Minnesota" },
        { code: "MS", name: "Mississippi" },
        { code: "MO", name: "Missouri" },
        { code: "MT", name: "Montana" },
        { code: "NE", name: "Nebraska" },
        { code: "NV", name: "Nevada" },
        { code: "NH", name: "New Hampshire" },
        { code: "NJ", name: "New Jersey" },
        { code: "NM", name: "New Mexico" },
        { code: "NY", name: "New York" },
        { code: "NC", name: "North Carolina" },
        { code: "ND", name: "North Dakota" },
        { code: "OH", name: "Ohio" },
        { code: "OK", name: "Oklahoma" },
        { code: "OR", name: "Oregon" },
        { code: "PA", name: "Pennsylvania" },
        { code: "RI", name: "Rhode Island" },
        { code: "SC", name: "South Carolina" },
        { code: "SD", name: "South Dakota" },
        { code: "TN", name: "Tennessee" },
        { code: "TX", name: "Texas" },
        { code: "UT", name: "Utah" },
        { code: "VT", name: "Vermont" },
        { code: "VA", name: "Virginia" },
        { code: "WA", name: "Washington" },
        { code: "WV", name: "West Virginia" },
        { code: "WI", name: "Wisconsin" },
        { code: "WY", name: "Wyoming" },
        { code: "DC", name: "District of Columbia" },
        { code: "AS", name: "American Samoa" },
        { code: "GU", name: "Guam" },
        { code: "MP", name: "Northern Mariana Islands" },
        { code: "UM", name: "United States Minor Outlying Islands" },
        { code: "PR", name: "Puerto Rico" },
        { code: "VI", name: "Virgin Islands, U.S." },
    ],
    CA: [
        { code: "AB", name: "Alberta" },
        { code: "BC", name: "British Columbia" },
        { code: "MB", name: "Manitoba" },
        { code: "NB", name: "New Brunswick" },
        { code: "NL", name: "Newfoundland and Labrador" },
        { code: "NT", name: "Northwest Territories" },
        { code: "NS", name: "Nova Scotia" },
        { code: "NU", name: "Nunavut" },
        { code: "ON", name: "Ontario" },
        { code: "PE", name: "Prince Edward Island" },
        { code: "QC", name: "Quebec" },
        { code: "SK", name: "Saskatchewan" },
        { code: "YT", name: "Yukon" },
    ],
    IN: [
        { code: "AN", name: "Andaman and Nicobar Islands" },
        { code: "AP", name: "Andhra Pradesh" },
        { code: "AR", name: "Arunāchal Pradesh" },
        { code: "AS", name: "Assam" },
        { code: "BR", name: "Bihār" },
        { code: "CH", name: "Chandīgarh" },
        { code: "CT", name: "Chhattīsgarh" },
        { code: "DL", name: "Delhi" },
        { code: "DH", name: "Dādra and Nagar Haveli and Damān and Diu" },
        { code: "GA", name: "Goa" },
        { code: "GJ", name: "Gujarāt" },
        { code: "HR", name: "Haryāna" },
        { code: "HP", name: "Himāchal Pradesh" },
        { code: "JK", name: "Jammu and Kashmīr" },
        { code: "JH", name: "Jhārkhand" },
        { code: "KA", name: "Karnātaka" },
        { code: "KL", name: "Kerala" },
        { code: "LA", name: "Ladākh" },
        { code: "LD", name: "Lakshadweep" },
        { code: "MP", name: "Madhya Pradesh" },
        { code: "MH", name: "Mahārāshtra" },
        { code: "MN", name: "Manipur" },
        { code: "ML", name: "Meghālaya" },
        { code: "MZ", name: "Mizoram" },
        { code: "NL", name: "Nāgāland" },
        { code: "OR", name: "Odisha" },
        { code: "PY", name: "Puducherry" },
        { code: "PB", name: "Punjab" },
        { code: "RJ", name: "Rājasthān" },
        { code: "SK", name: "Sikkim" },
        { code: "TN", name: "Tamil Nādu" },
        { code: "TG", name: "Telangāna" },
        { code: "TR", name: "Tripura" },
        { code: "UP", name: "Uttar Pradesh" },
        { code: "UT", name: "Uttarākhand" },
        { code: "WB", name: "West Bengal" },
    ],
    BR: [
        { code: "AC", name: "Acre" },
        { code: "AL", name: "Alagoas" },
        { code: "AP", name: "Amapá" },
        { code: "AM", name: "Amazonas" },
        { code: "BA", name: "Bahia" },
        { code: "CE", name: "Ceará" },
        { code: "DF", name: "Distrito Federal" },
        { code: "ES", name: "Espírito Santo" },
        { code: "GO", name: "Goiás" },
        { code: "MA", name: "Maranhão" },
        { code: "MT", name: "Mato Grosso" },
        { code: "MS", name: "Mato Grosso do Sul" },
        { code: "MG", name: "Minas Gerais" },
        { code: "PA", name: "Pará" },
        { code: "PB", name: "Paraíba" },
        { code: "PR", name: "Paraná" },
        { code: "PE", name: "Pernambuco" },
        { code: "PI", name: "Piauí" },
        { code: "RJ", name: "Rio de Janeiro" },
        { code: "RN", name: "Rio Grande do Norte" },
        { code: "RS", name: "Rio Grande do Sul" },
        { code: "RO", name: "Rondônia" },
        { code: "RR", name: "Roraima" },
        { code: "SC", name: "Santa Catarina" },
        { code: "SP", name: "São Paulo" },
        { code: "SE", name: "Sergipe" },
        { code: "TO", name: "Tocantins" },
    ],
};

export { states };
//# sourceMappingURL=states.js.map
